var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "dropdown-item d-flex align-items-center",
      attrs: { type: "button" },
      on: { click: _setup.openFindModal },
    },
    [_c("i", { staticClass: "me-2 bi-search" }), _vm._v("\n    Find\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }